export const FILTER_MODAL_TEST_ID_BASE = "sort-and-filter-modal";

export const FILTER_MODAL_TEST_ID = {
  category: `${FILTER_MODAL_TEST_ID_BASE}-category`,
  browse: `${FILTER_MODAL_TEST_ID_BASE}-browse`,
  showMore: `${FILTER_MODAL_TEST_ID_BASE}-show-more`,
};

// Keyed by the middle segment of a showMore rel, which looks like
// "search-quick-types.<ATTRIBUTE>.<id>" — e.g. search-quick-types.PROVIDERS.BIG.
// GAME_MODELS maps to "type" on purpose: the rel tracks the Elasticsearch field,
// the test id tracks what the surface is called. Same crossover CategoryFilters
// makes when it renders the game-models rel with the "types" translation key.
const ATTRIBUTE_TEST_ID = {
  PROVIDERS: `${FILTER_MODAL_TEST_ID_BASE}-specific-provider`,
  GAME_MODELS: `${FILTER_MODAL_TEST_ID_BASE}-specific-type`,
  SPECIAL_FEATURES: `${FILTER_MODAL_TEST_ID_BASE}-specific-feature`,
  THEMES: `${FILTER_MODAL_TEST_ID_BASE}-specific-theme`,
};

export function filterModalTestId(showMoreRel) {
  if (typeof showMoreRel !== "string") {
    return FILTER_MODAL_TEST_ID.showMore;
  }

  // Match the middle segment, never a substring: "search-quick-types" prefixes
  // every one of these rels, so testing the whole string for "types" is true for
  // providers and themes too. The trailing segment is the individual value's id.
  const segments = showMoreRel.split(".");
  const attribute = segments.length === 3 ? segments[1] : null;

  return ATTRIBUTE_TEST_ID[attribute] || FILTER_MODAL_TEST_ID.showMore;
}
